import React, { useState } from 'react';

const days = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

const planningContainsRangeForAllDays = (planning: number[][], range: number[]) => {
    return planning.every((day) => range.every((r) => day.indexOf(r) !== -1));
};

const getWeekArrayFromArray = (arr: number[]) => {
    return [1, 2, 3, 4, 5, 6, 7].map((_) => [...arr]);
};

const selectRange = (range: number[], planning: number[][]) => {
    const currentPlanning = [...planning];

    if (planningContainsRangeForAllDays(currentPlanning, range)) {
        // Deselect
        for (const p of currentPlanning) {
            for (const r of range) {
                const index = p.indexOf(r);
                if (index !== -1) {
                    p.splice(index, 1);
                }
            }
        }
    } else {
        for (const p of currentPlanning) {
            for (const r of range) {
                const index = p.indexOf(r);
                if (index === -1) {
                    p.push(r);
                }
            }
        }
    }

    for (const p of currentPlanning) {
        p.sort((a, b) => a - b);
    }

    return currentPlanning;
};

const handlePlanningHour = (h: number, planning: number[][]) => selectRange([h], planning);

const generateTimeBlocks = (day: number[]) => {
    const blocks = [];

    for (let i = 0; i < day.length; i++) {
        let j = i + 1;
        let end = day[i];
        while (j < day.length && day[j] === day[j - 1] + 1) {
            end = day[j];
            j++;
        }

        if (end === day[i]) {
            blocks.push(`${day[i]}h`);
        } else {
            blocks.push(`${day[i]} - ${end}`);
        }

        i = j - 1;
    }

    return blocks;
};

export const PlanningWeek = (props: { planning: number[][]; setPlanning: (planning: number[][]) => void }) => {
    const [state, setState] = useState({
        dayModalOpen: -1
    });

    return (
        <div className="Planning">
            <div className="tableMobCtr">
                <table className="table fixed">
                    <thead>
                        <tr>
                            <th>Tous</th>
                            {days.map((d, i) => (
                                <td className="center" key={d}>
                                    {d}
                                </td>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Sélection</td>
                            {props.planning.map((p, i) => {
                                if (p.length > 0) {
                                    return (
                                        <td
                                            key={i}
                                            className="center"
                                            onClick={() =>
                                                setState({ ...state, dayModalOpen: state.dayModalOpen === i ? -1 : i })
                                            }
                                        >
                                            {generateTimeBlocks(p).map((p, j) => (
                                                <div style={{ cursor: 'pointer' }} key={p}>
                                                    <span key={j} className="label label-default timeRange">
                                                        {p}
                                                    </span>
                                                </div>
                                            ))}
                                        </td>
                                    );
                                } else {
                                    return (
                                        <td
                                            key={i}
                                            className="center"
                                            onClick={() =>
                                                setState({ ...state, dayModalOpen: state.dayModalOpen === i ? -1 : i })
                                            }
                                        >
                                            <div
                                                style={{
                                                    cursor: 'pointer',
                                                    border: '2px dashed #eee',
                                                    borderRadius: 5
                                                }}
                                            >
                                                +
                                            </div>
                                        </td>
                                    );
                                }
                            })}
                        </tr>
                    </tbody>
                </table>
                {state.dayModalOpen === -1 || (
                    <div
                        className="modal-days-planning"
                        onClick={(e) => {
                            if (e.target === e.currentTarget) {
                                setState({
                                    ...state,
                                    dayModalOpen: -1
                                });
                            }
                        }}
                    >
                        <div className="modal-days-planning-body">
                            <h6 className="center">{days[state.dayModalOpen]}</h6>
                            <PlanningBlock
                                planning={new Array(7).fill(props.planning[state.dayModalOpen])}
                                setPlanning={(p) => {
                                    const planning = [...props.planning];
                                    planning[state.dayModalOpen] = p[0];

                                    props.setPlanning(planning);
                                }}
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export const PlanningBlock = (props: { planning: number[][]; setPlanning: (planning: number[][]) => void }) => {
    return (
        <div className="ModalPlanning">
            <span className="selectAll">
                Jour plein{' '}
                <span
                    className={[
                        'checkbox',
                        planningContainsRangeForAllDays(
                            props.planning,
                            [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22]
                        )
                            ? 'checked'
                            : ''
                    ].reduce((acc, e) => acc + ' ' + e)}
                    onClick={(_) => {
                        let newPlanning = props.planning;

                        newPlanning =
                            props.planning[0].length === 16
                                ? getWeekArrayFromArray([])
                                : getWeekArrayFromArray([7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22]);

                        props.setPlanning(newPlanning);
                    }}
                />
            </span>
            <h6 className="center">Choix tranches</h6>
            <div className="slices">
                <div
                    className={`block${
                        planningContainsRangeForAllDays(props.planning, [7, 8, 9, 10]) ? ' selected' : ''
                    }`}
                    onClick={() => props.setPlanning(selectRange([7, 8, 9, 10], props.planning))}
                >
                    <span>7h-11h</span>
                </div>
                <div
                    className={`block${
                        planningContainsRangeForAllDays(props.planning, [11, 12, 13, 14, 15, 16]) ? ' selected' : ''
                    }`}
                    onClick={() => props.setPlanning(selectRange([11, 12, 13, 14, 15, 16], props.planning))}
                >
                    <span>11h-17h</span>
                </div>
                <div
                    className={`block${
                        planningContainsRangeForAllDays(props.planning, [17, 18, 19, 20, 21, 22]) ? ' selected' : ''
                    }`}
                    onClick={() => props.setPlanning(selectRange([17, 18, 19, 20, 21, 22], props.planning))}
                >
                    <span>17h-22h</span>
                </div>
            </div>
            <h6 className="center">Choix heures</h6>
            <div className="timing">
                {Array(16)
                    .fill(0)
                    .map((_, h) => (
                        <div
                            className={`block${
                                planningContainsRangeForAllDays(props.planning, [h + 7]) ? ' selected' : ''
                            }`}
                            key={h}
                            onClick={() => props.setPlanning(handlePlanningHour(h + 7, props.planning))}
                        >
                            <span>{h + 7}</span>
                        </div>
                    ))}
            </div>
        </div>
    );
};
